import * as React from "react";
import { forwardRef } from "react";
const SvgX = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-x", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("line", { x1: 18, y1: 6, x2: 6, y2: 18 }), /* @__PURE__ */ React.createElement("line", { x1: 6, y1: 6, x2: 18, y2: 18 }));
const ForwardRef = forwardRef(SvgX);
export { ForwardRef as ReactComponent };
